import { render, staticRenderFns } from "./InputDate.vue?vue&type=template&id=76ddabd9&"
import script from "./InputDate.vue?vue&type=script&lang=js&"
export * from "./InputDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Pipelines\\release\\06.04\\maintenance\\Fontes\\corp\\produto\\wes\\WebApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76ddabd9')) {
      api.createRecord('76ddabd9', component.options)
    } else {
      api.reload('76ddabd9', component.options)
    }
    module.hot.accept("./InputDate.vue?vue&type=template&id=76ddabd9&", function () {
      api.rerender('76ddabd9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "content/components/Wes/InputDate.vue"
export default component.exports